import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { SUB_MODULE } from "../apiRoutes";

const mutateUpdateSubmodule = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${SUB_MODULE}${id}`, data);
};

const useUpdateSubmodulesMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateSubmodule,
    ...queryParams,
  });

export default useUpdateSubmodulesMutation;
